import React from 'react'
import { useTranslation } from 'react-i18next'
import { PricingPlan } from '../../interfaces/pricingPlan'
import moment from 'moment'
import { extractNumberFromString } from '../../helpers/extractNumberFromString'

interface Props {
  pricingPlan: PricingPlan
}

const ReviewPlan = ({ pricingPlan }: Props) => {
  const { t } = useTranslation()
  const planName = pricingPlan.product.base_name
  const isYearly = pricingPlan.product.interval_type === 'yearly'
  // `seats` is null on a product that does not declare one, and
  // `null.includes` would take the whole screen down with it.
  const seats = pricingPlan.product.seats ?? ''
  const isCompany = pricingPlan.product.product_type === 'company'
  const price = pricingPlan.amount
  const unit = isCompany ? t('employees') : t('students')
  const expirationDate = isYearly
    ? moment().add(1, 'year').format('MMMM D, YYYY')
    : moment().add(1, 'month').format('MMMM D, YYYY')
  const isUpTo = !seats.includes('>')
  return (
    <div className='flex flex-col my-[50px]'>
      <h2 className='text-[24px] font-bold'>{t('yourPlan')}</h2>
      <div className='flex items-center gap-2 mt-8 mb-5'>
        <p className='text-lg font-semibold'>{planName}</p>
        <p className='text-lightGray'>
          {t('expiresIn')} {expirationDate}
        </p>
      </div>
      <p className='text-lg text-textBlack mb-5'>
        {t('youHaveSelectedThe')} {planName} {t('membershipPlan')}
      </p>
      <p className='text-textBlack mb-2'>
        {t('seatsPlanDescription', {
          range: isUpTo ? t('upTo') : t('moreThan'),
          seats: extractNumberFromString(seats),
          unit,
          productType: isCompany
            ? t('company')?.toLowerCase()
            : t('yourUniversity'),
        })}
      </p>
      <p className='text-textBlack'>
        {t('myPlanDescription', {
          months: isYearly ? 12 : 1,
          monthsLabel: isYearly ? t('months') : t('month'),
          price,
        })}
      </p>
      <p className='text-textBlack mt-2'>
        {t('thePriceOfMembership')} €{price}.
      </p>
    </div>
  )
}

export default ReviewPlan
